export const THEMES = {
  light: {
    bg: "#f8fafc",
    cardBg: "white",
    cardBorder: "#eee",
    text: "#0f172a",
    textSub: "#475569",
    textMuted: "#94a3b8",
    inputBg: "white",
    inputBorder: "#e5e7eb",
    headerBg: "rgba(248,250,252,0.92)",
    tableBg: "#f8fafc",
    tableHover: "#f1f5f9",
    sectionBg: "#f8fafc",
    errorBg: "#fef2f2",
    errorBorder: "#fecaca",
    errorText: "#991b1b",
    successBg: "#f0fdf4",
    successText: "#16a34a",
    warningBg: "#fefce8",
    warningText: "#f59e0b",
    successBorder: "#bbf7d0",
    warningBorder: "#fef08a",
    infoBg: "#eff6ff",
    infoBorder: "#bfdbfe",
    infoText: "#1d4ed8",
  },
  dark: {
    bg: "#0f172a",
    cardBg: "#1e293b",
    cardBorder: "#334155",
    text: "#f1f5f9",
    textSub: "#cbd5e1",
    textMuted: "#64748b",
    inputBg: "#0f172a",
    inputBorder: "#334155",
    headerBg: "rgba(15,23,42,0.92)",
    tableBg: "#1e293b",
    tableHover: "#334155",
    sectionBg: "#0f172a",
    errorBg: "#450a0a",
    errorBorder: "#7f1d1d",
    errorText: "#fca5a5",
    successBg: "#052e16",
    successText: "#4ade80",
    warningBg: "#422006",
    warningText: "#fbbf24",
    successBorder: "#166534",
    warningBorder: "#854d0e",
    infoBg: "#172554",
    infoBorder: "#1e3a5f",
    infoText: "#93c5fd",
  },
};

export const COLORS = [
  "#3B82F6", "#10B981", "#F59E0B", "#EF4444", "#8B5CF6", "#EC4899",
  "#06B6D4", "#F97316", "#14B8A6", "#6366F1", "#84CC16", "#78716C",
];
